module.exports = __webpack_public_path__ + "img/guide10.b1103d61.jpg";